module.exports = require('./generateIngredientInstance')
